import { Component } from 'react'
import styled from '@emotion/styled'

interface Props {
  options: { active: boolean; value: string; label: string }[]
  onOptionSelected: (option: string) => void
  style?: React.CSSProperties
  variant?: 'primary' | 'secondary'
  onclick?: any
  type?: 'circle' | 'square'
}

export class Tab extends Component<Props> {
  render() {
    const { options, onOptionSelected, style, onclick, variant = 'primary', type = 'circle' } = this.props
    if (!options || options.length === 0) {
      return <></>
    }

    return (
      <OptionsContainer
        type={type}
        data-testid={`tab`}
        data-cy={options.map((option) => option.label).join(', ')}
        style={style}
      >
        {options.map((option) => (
          <OptionButton
            type={type}
            data-testid={`option-${option.value}`}
            data-cy={option.label}
            variant={variant}
            key={`option-${option.value}`}
            active={option.active}
            onClick={() => (onclick ? onclick(option.value) : onOptionSelected(option.value))}
          >
            {option.label}
          </OptionButton>
        ))}
      </OptionsContainer>
    )
  }
}

const OptionsContainer = styled.div<{ type: 'circle' | 'square' }>`
  height: ${({ type }) => (type === 'circle' ? '77px' : '100%')};
  background: #ffffff;
  border-radius: ${({ type }) => (type === 'circle' ? '100px' : '10px')};
  padding: ${({ type }) => (type === 'circle' ? '0 10px' : '0 3px')};
  display: flex;
  flex-direction: row;
  align-items: center;
  border: ${({ type }) => (type === 'circle' ? 'none' : '2px solid #D2D2D2')};
`

const OptionButton = styled.div<{ variant: 'primary' | 'secondary'; active: boolean; type: 'circle' | 'square' }>`
  display: flex;
  padding-left: 10px;
  padding-right: 10px;
  min-width: 150px;
  height: 57px;
  border-radius: ${({ type }) => (type === 'circle' ? '100px' : '10px')};
  background: ${({ active, variant, theme }) => (active ? theme[`${variant}Bg`] : 'white')};
  font-style: normal;
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  ${({ variant, active }) => variant === 'secondary' && active && `color: white;`}
`
